import React, {useState, useContext} from 'react';
import {useQueryClient} from "react-query";
import __ from "lodash";
import {FormGroup, FormControl, Grid, Button, useTheme} from "@material-ui/core";

import {Form, LabelledPaper, Text} from '../../../controls';
import SystemContext from "../../../SystemContext";
import {useComboValues} from "../../../services/settings";
import {useAirportsLastMovement} from "../../../services/aircraft";
import moment from 'moment';
import { useAirports } from '../../../services/airports';
import { useTripLeg } from '../../../services/trips';

const AirportsLastMovement = (_props) => {
  const props = {
    canEdit: false,
    ..._props
  }
  const classes = props.classes;
  const SystemData = useContext(SystemContext);
  const theme = useTheme();

  const [record, setRecord] = useState(props.record);

  const eventBus = SystemData.eventBus;
  if (eventBus) {
    eventBus.bind('AirportList.rowSelected', (record)=> {
      setRecord(record);
    });
  }

  const queryClient = useQueryClient();

  const airportExtraKeys = [record?record.airportCode:"---"];
  const airportsLastMovement = useAirportsLastMovement({queryClient, extraKeys: airportExtraKeys});
  const destinationAirportName = useAirports({ queryClient, extraKeys: [airportsLastMovement?.data?.destinationAirportCodeIata||"---"], useCache: true});
  const tripLeg = useTripLeg({queryClient, extraKeys: [airportsLastMovement?.data?.tripLegUuid||"---"]});

  let std = ["-- ---","--:--"];
  let sta = ["-- ---","--:--"];
  let etd = ["-- ---","--:--"];
  let bloff = ["-- ---","--:--"];
  let takeoff = ["-- ---","--:--"];
  let eta = ["-- ---","--:--"];
  let ldg = ["-- ---","--:--"];
  let blon = ["-- ---","--:--"];
  
  let tripNo = "";
  let flightNo = "";
  let aircraftReg = "";

  if (tripLeg && Array.isArray(tripLeg.data) && tripLeg.data.length > 0) {
    std = [moment.utc(tripLeg.data[0].scheduleDepartureTimeUTC).format('DD MMM'), moment.utc(tripLeg.data[0].scheduleDepartureTimeUTC).format('HH:mm') ];
    sta = [moment.utc(tripLeg.data[0].scheduleArrivalTimeUTC).format('DD MMM'), moment.utc(tripLeg.data[0].scheduleArrivalTimeUTC).format('HH:mm') ];
    if (tripLeg.data[0].estimatedDepartureTimeUTC) {
      etd = [moment.utc(tripLeg.data[0].estimatedDepartureTimeUTC).format('DD MMM'), moment.utc(tripLeg.data[0].estimatedDepartureTimeUTC).format('HH:mm') ];
    }
    if (tripLeg.data[0].estimatedArrivalTimeUTC) {
      eta = [moment.utc(tripLeg.data[0].estimatedArrivalTimeUTC).format('DD MMM'), moment.utc(tripLeg.data[0].estimatedArrivalTimeUTC).format('HH:mm') ];
    }
    tripNo = `${tripLeg.data[0].tripPrefix} ${tripLeg.data[0].tripNo}`;
    flightNo = `${tripLeg.data[0].airlineCode} ${tripLeg.data[0].flightNo}`;
    aircraftReg = tripLeg.data[0].aircraftId;
  }
  if (airportsLastMovement && airportsLastMovement.data) {

    if (airportsLastMovement.data.etaUTC && eta[0] === "-- ---") {
      eta = [moment.utc(airportsLastMovement.data.etaUTC).format('DD MMM'), moment.utc(airportsLastMovement.data.etaUTC).format('HH:mm') ];
    }
    if (airportsLastMovement.data.offBlocksTimeUTC) {
      bloff = [moment.utc(airportsLastMovement.data.offBlocksTimeUTC).format('DD MMM'), moment.utc(airportsLastMovement.data.offBlocksTimeUTC).format('HH:mm') ];
    }  
    if (airportsLastMovement.data.takeOffTimeUTC) {
      takeoff = [moment.utc(airportsLastMovement.data.takeOffTimeUTC).format('DD MMM'), moment.utc(airportsLastMovement.data.takeOffTimeUTC).format('HH:mm') ];
    }
    if (airportsLastMovement.data.landingTimeUTC) {
      ldg = [moment.utc(airportsLastMovement.data.landingTimeUTC).format('DD MMM'), moment.utc(airportsLastMovement.data.landingTimeUTC).format('HH:mm') ];
    }
    if (airportsLastMovement.data.onBlocksTimeUTC) {
      blon = [moment.utc(airportsLastMovement.data.onBlocksTimeUTC).format('DD MMM'), moment.utc(airportsLastMovement.data.onBlocksTimeUTC).format('HH:mm') ];
    }
  }

  return (
    <div key="formContainer" style={{width: "100%", textAlign:"left"}}>
      {record ?
        <Form
          key="form"
          title={(record)=>{return `Last Movement for ${record.airportName}`}}
          message=""
          open={true}
          record={record}
          top={"calc(100vh - 274px)"}
          formTitleStyle={{padding: "16px 16px"}}
          titleBarStyle={{backgroundColor: '#3f3f3f', color: theme.palette.primary.main, padding: "6px"}}
          formBodyStyle={{maxHeight: "calc(100vh - 360px)"}}
          buttonBarStyle={{width: "calc(100% - 16px)"}}
          buttons = {{}}
        >

          <Grid container spacing={3}>
            <Grid item xs={12} >
              <LabelledPaper label="Movement">
                <FormControl key="FC-movement" style={{display: "block"}}>
                  <FormGroup key="FG-movement" row>
                    <Grid container spacing={3}>
                      <Grid item xs={1.5}>
                        <Text id="movementType" label="Movement Type" value={airportsLastMovement?.data?.movementType||''} style={{width: "100%"}}/>
                      </Grid>
                      <Grid item xs={2}>
                        <Text id="movementTime" label="Movement Time" value={moment.utc(airportsLastMovement?.data?.actualMovementTimeUTC).format("DD MMM YYYY HH:mm")} style={{width: "100%"}}/>
                      </Grid>
                      <Grid item xs={2.5}>
                        <Text id="arriving" label="Destination" value={`${airportsLastMovement?.data?.destinationAirportCodeIata||''} - ${Array.isArray(destinationAirportName?.data) && destinationAirportName.data.length>0 ? destinationAirportName.data[0].airportName : ''}`} style={{width: "100%"}}/>
                      </Grid>
                      <Grid item xs={1.5}>
                        <Text id="trip" label="Trip No" value={tripNo} style={{width: "100%"}}/>
                      </Grid>
                      <Grid item xs={1}>
                        <Text id="flight" label="Flight No" value={flightNo} style={{width: "100%"}}/>
                      </Grid>
                      <Grid item xs={1}>
                        <Text id="aircraft" label="Aircraft Reg" value={aircraftReg} style={{width: "100%"}}/>
                      </Grid>
                    </Grid>
                  </FormGroup>
                </FormControl>
              </LabelledPaper>
            </Grid>
            <Grid item xs={12} />
            <Grid item xs={12} >
              <LabelledPaper label="Times">
                <FormControl key="FC-movement" style={{display: "block"}}>
                  <FormGroup key="FG-movement" row>
                    <Grid container spacing={3}>
                      <Grid item xs={12}>
                        <Grid 
                          container direction="row"
                          justifyContent="space-evenly"
                          nowrap="true"
                        >
                          <Grid item nowrap="true" key="STD" >
                            <div class={classes.timeBlock}>
                              <div class={classes.header}>STD</div>
                              <div class={classes.date}>{std[0]} {std[1]}</div>
                            </div>
                          </Grid>
                          <Grid item  nowrap="true" key="ETD">
                            <div class={classes.timeBlock}>
                              <div class={classes.header}>ETD</div>
                              <div class={classes.date}>{etd[0]} {etd[1]}</div>
                            </div>
                          </Grid>
                          <Grid item  nowrap="true" key="BLOFF">
                            <div class={classes.timeBlock}>
                              <div class={classes.header}>BLOFF</div>
                              <div class={classes.date}>{bloff[0]} {bloff[1]}</div>
                            </div>
                          </Grid>
                          <Grid item  nowrap="true" key="TO">
                            <div class={classes.timeBlock}>
                              <div class={classes.header}>T/O</div>
                              <div class={classes.date}>{takeoff[0]} {takeoff[1]}</div>
                            </div>
                          </Grid>
                          <Grid item  nowrap="true" key="STA">
                            <div class={classes.timeBlock}>
                              <div class={classes.header}>STA</div>
                              <div class={classes.date}>{sta[0]} {sta[1]}</div>
                            </div>
                          </Grid>
                          <Grid item  nowrap="true" key="ETA">
                            <div class={classes.timeBlock}>
                              <div class={classes.header}>ETA</div>
                              <div class={classes.date}>{eta[0]} {eta[1]}</div>
                            </div>
                          </Grid>
                          <Grid item  nowrap="true" key="LDG">
                            <div class={classes.timeBlock}>
                              <div class={classes.header}>LDG</div>
                              <div class={classes.date}>{ldg[0]} {ldg[1]}</div>
                            </div>
                          </Grid>
                          <Grid item  nowrap="true" key="BLON">
                            <div class={classes.timeBlock}>
                              <div class={classes.header}>BLON</div>
                              <div class={classes.date}>{blon[0]} {blon[1]}</div>
                            </div>
                          </Grid>
                        </Grid>        
                      </Grid>
                    </Grid>
                  </FormGroup>
                </FormControl>
              </LabelledPaper>
            </Grid>
          </Grid>
        </Form>
        :
        <div style={{ position: "relative", width: "100%", top: "50%", height: "calc(100vh - 220px)", textAlign: "center"}}>
          <Button color={"primary"}>Select an Airport to view movement details</Button>
        </div>
      }
    </div>
  );
}

export default AirportsLastMovement;
